import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfoGroup from '../InfoGroup/InfoGroup';
import UsersInActivityTable from '../UsersInActivityTable/UsersInActivityTable';
import TabButtons from '../TabButtons/TabButtons';
import api from '../../Api/api';
import {
  REQUEST_GET_ACTIVITY_DATA,
  REQUEST_GET_ALL_ACTIVITIES,
  CLEAR_CURRENT_ACTIVITY,
  REQUEST_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
  REQUEST_GET_ACTIVITY_STATS,
} from '../../Redux/constants/constants';
import { Modal, Collapse, Typography, Empty } from 'antd';
import ActivityStats from '../ActivityStats/ActivityStats';

const { confirm } = Modal;
const { Panel } = Collapse;
const { Title } = Typography;

const ActivityTab = ({
  isEditing,
  projectId,
  activeKey,
  thisKey,
  userView,
}) => {
  const [editing, setEditing] = useState(isEditing);
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState({});
  const dispatch = useDispatch();
  const currentActivity = useSelector((state) => state.currentActivity);

  useEffect(() => {
    setLocalData(currentActivity);
    if (currentActivity.newActivity === true) {
      setEditing(true);
    } else {
      setEditing(false);
    }
  }, [currentActivity]);

  useEffect(() => {
    if (localData.id) {
      dispatch({
        type: REQUEST_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
        payload: localData.id,
      });
      !userView &&
        dispatch({
          type: REQUEST_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
          payload: localData.id,
        });
      !userView &&
        dispatch({
          type: REQUEST_GET_ACTIVITY_STATS,
          payload: localData.id,
        });
    }
  }, [localData.id]);
  /**/

  // for User account
  // check if logged in user is in stage
  // based on it display join or leave stage
  /*
  useEffect(() => {
    if (authUserData !== undefined && usersInStage !== undefined) {
      const isUserInStage = usersInStage
        .map(user => user.email)
        .filter(email => email === authUserData.email);
      setUserInStage(isUserInStage.length > 0);
    }
  }, [authUserData, usersInStage]);
  /**/

  const handleClick = (value) => {
    if (value === 'save') {
      setLoading(true);
      api
        .postActivityData({
          id: localData.id,
          name: localData.name,
        })
        .then((res) => {
          setEditing(false);
          setLoading(false);
          dispatch({
            type: REQUEST_GET_ACTIVITY_DATA,
            payload: res.data.id,
          });
          dispatch({ type: REQUEST_GET_ALL_ACTIVITIES });
        })
        .catch(() => {
          setEditing(false);
          setLoading(false);
          console.log('some error during save');
        });
    }
    if (value === 'edit') setEditing(true);
    if (value === 'cancel') {
      setEditing(false);
      dispatch({
        type: REQUEST_GET_ACTIVITY_DATA,
        payload: localData.id,
      });
    }
    if (value === 'delete') {
      showConfirm();
    }
  };

  const showConfirm = () => {
    confirm({
      title: 'Czy chcesz usunąć tą aktywnowść?',
      content: `${localData.name}`,
      okType: 'danger',
      okText: 'Usuń',
      cancelText: 'Anuluj',
      onOk() {
        api
          .deleteActivity({
            id: localData.id,
          })
          .then((res) => {
            setEditing(false);
            setLoading(false);
            dispatch({ type: CLEAR_CURRENT_ACTIVITY });
            dispatch({ type: REQUEST_GET_ALL_ACTIVITIES });
          })
          .catch(() => {
            setEditing(false);
            setLoading(false);
            console.log('some error during delete');
          });
      },
      onCancel() {},
    });
  };

  const onChange = (value, key) => {
    setLocalData({ ...localData, [key]: value });
  };

  return (
    <>
      <Title
        level={3}
        style={{ marginBottom: '24px', marginTop: '0px', height: '36px' }}
      >
        {currentActivity.name ? `${currentActivity.name}` : ''}
      </Title>
      <ActivityStats />
      <InfoGroup
        editable
        type={'text'}
        text={'Nazwa'}
        placeHolder={'Nazwa Aktywności'}
        data={localData.name || ''}
        editing={editing}
        id={'name'}
        onChange={onChange}
      />
      {!userView && (
        <TabButtons
          editing={editing}
          handleClick={handleClick}
          loading={loading}
          isProjectLoaded={true}
        />
      )}
      <Collapse
        bordered={false}
        style={{ borderRadius: '0', borderBottom: '0' }}
      >
        <Panel
          header="Pracownicy"
          key="1"
          style={{ borderRadius: '0', borderBottom: '0' }}
        >
          <UsersInActivityTable
            activityId={localData.id}
            activeKey={activeKey}
            thisKey={thisKey}
            userView={userView}
          />
        </Panel>
        <Panel
          header="Wpływy | Wydatki"
          key="2"
          style={{ borderRadius: '0', borderBottom: '0' }}
        >
          <Empty description={<span>W przygotowaniu</span>} />
        </Panel>
      </Collapse>
    </>
  );
};

export default ActivityTab;
